import firebase from '../../lib/firebase.prod';

const firebaseRef = firebase.database();

export async function editRole(
	projectId,
	roleId,
	roleName,
	accessibilityCheckbox,
	color
) {
	if (!projectId) {
		return {
			success: false,
		};
	}

	if (!roleId) {
		return {
			success: false,
		};
	}

	let role = firebaseRef.ref('/kavtek_roles/' + projectId + '/' + roleId);
	let accessibilities = {};
	for (let key in accessibilityCheckbox) {
		if (accessibilityCheckbox[key]) {
			let [module, feature, action] = key.split('-');

			if (!accessibilities[module]) {
				accessibilities[module] = {};
			}
			if (!accessibilities[module][feature]) {
				accessibilities[module][feature] = [];
			}
			accessibilities[module][feature].push(Number(action));
		}
	}

	role.update({
		roleName: roleName,
		accessibilities: accessibilities,
		color: color,
	});

	return {
		success: true,
	};
}
